import { formatApiPrice } from '@application/utils';
import type { MtLittersGetLittersQuery } from '@gql/graphql';
import type { MtCardItemLitterData } from '@presentation/components';
import { useTranslation } from '@presentation/utils';
import dayjs from 'dayjs';
import { useCallback } from 'react';

export const useFormatLitters = () => {
  const { translate } = useTranslation();

  const formatLitter = useCallback(
    (
      litter: NonNullable<
        NonNullable<MtLittersGetLittersQuery['accountMe']>['dogBreeder']
      >['litters'][number],
    ): MtCardItemLitterData => {
      return {
        breed: litter.dogBreed?.translations[0]?.name,
        image: litter.imgs?.[0]?.small ?? litter.dogBreed?.imgs?.[0]?.small,
        archived: !!litter.archived,
        waiting: !litter.adminValidated,
        price: formatApiPrice({ ...litter }),
        ...(litter.birthday && dayjs(litter.birthday)?.valueOf() > dayjs().valueOf()
          ? {
              futureLitter: {
                month: dayjs(litter.birthday).format('MMMM'),
                year: dayjs(litter.birthday)?.format('YYYY'),
              },
            }
          : {}),
        footer: (
          <div>
            {translate('glossary.malesLeft').replace(
              '$malesLeftCount',
              (litter.malesLeftCount ?? 0).toString(),
            )}
            <br />
            {translate('glossary.femalesLeft').replace(
              '$femalesLeftCount',
              (litter.femalesLeftCount ?? 0).toString(),
            )}
          </div>
        ),
      };
    },
    [translate],
  );

  return { formatLitter };
};
